<template>
  <div class="app-container">
    <div class="container">
      <div class="row medium upper small">
        <div class="col-md-4">{{total}} open positions</div>
        <div class="col-sm-1 offset-1 show-desktop" v-if="total > 0">City</div>
        <div class="col-sm-3 offset-1 show-desktop" v-if="total > 0">Tags</div>
      </div>
    </div>
    <div class="container zero-state" v-if="total === 0">
      <div class="row">
        <div class="col-sm-8">
          <h5>We don't have an open position like that right now.<br> Check back soon or try something else.</h5>
        </div>
      </div>
    </div>
    <CareersItem v-for="(career, index) in careers" v-bind:data="career" v-bind:key="index" />
    <div class="app-footer">
      <div v-if="careers.length < total" v-on:click="loadMore" class="load-more">
        <button class="sc_btn"><svg><use xlink:href="#plus"></use></svg>See more positions<span><em><svg><use xlink:href="#plus"></use></svg>See more positions</em></span></button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CareersItem from './CareersItem.vue'

export default {
  components: {CareersItem},
  name: 'CareersList',
  methods: {
    loadMore: function() {
      this.$store.dispatch('getData')
    }
  },
  computed: {
    ...mapGetters({
      total: 'getTotal',
      careers: 'getCareers'
    })
  },
  mounted: function() {
    this.$store.dispatch('getData', 'init')
  }
}
</script>